import { Icon, IconType } from '../icons';
import { cn, IDynamicListHeaderProps } from 'types';

export const ListHeader = (props: IDynamicListHeaderProps) => {
  const { config, sort, onSortChange, className = '' } = props;
  if (config?.noHeader) return null;

  return (
    <div
      className={cn('col-span-full grid [grid-template-columns:var(--grid-cols)] bg-lightGrey rounded-t-lg', className)}
    >
      {config?.cols?.map((col, index) => (
        <div
          key={`header_${col.key}_${index}`}
          onClick={() => (col.noSort ? {} : onSortChange(col.key))}
          className={cn('px-6 py-3 flex items-center gap-2', config?.commonHeaderClassName ?? '', col?.headerClassName)}
        >
          <span className={cn('font-extrabold leading-[175%] capitalize', !col.noSort && 'cursor-pointer')}>
            {col.header}
          </span>
          {!col.noSort && col.key === sort?.[0]?.key && (
            <Icon
              icon={
                sort?.[0]?.reverse
                  ? (config?.sortingIcon?.iconDropdownUp ?? IconType.TableArrowUp)
                  : (config?.sortingIcon?.iconDropdownDown ?? IconType.TableArrowDown)
              }
              height={config?.sortingIcon?.iconHeight ?? 10}
              width={config?.sortingIcon?.iconWidth ?? 10}
              fill={config?.sortingIcon?.iconColor ?? ''}
            />
          )}
        </div>
      ))}
    </div>
  );
};
